export default __webpack_public_path__ + "static/media/home-decor-img-02.5b3d5377.jpg";